import { AttentionTriangleIcon, AviveCheckIcon } from '@rsos/assets/icons';

export const deriveBannerState = (error, isSuccess) => {
  if (error) return 'error';
  if (isSuccess) return 'success';

  return 'idle';
};

export const getBannerStateUI = (bannerState, isLoading) => {
  switch (bannerState) {
    case 'success':
      return {
        bannerColor: 'success',
        bannerText: 'Successfully retrieved data and device language ',
        BannerIcon: (
          <AviveCheckIcon color="background" width={20} height={20} />
        ),
      };
    case 'error':
      return {
        bannerColor: 'lightDanger',
        bannerText: 'Failed to retrieve data and device language.',
        BannerIcon: (
          <AttentionTriangleIcon color="background" width={16} height={16} />
        ),
      };
    default:
      return {
        bannerColor: 'primaryBase',
        bannerText: isLoading
          ? 'Requesting additional data and device language'
          : 'Request additional data and device language?',
        BannerIcon: null,
      };
  }
};
